import {
    AuthService,
    DonorService,
    ExternalService,
    GiftService,
    HomeService,
    OnlineGivingService,
    PointsService,
} from './resources';

export class ApiHandler {
    private static _instance: ApiHandler;
    public auth: AuthService;
    public donor: DonorService;
    public externalServices: ExternalService;
    public gift: GiftService;
    public home: HomeService;
    public onlineGiving: OnlineGivingService;
    public points: PointsService;

    constructor() {
        this.auth = new AuthService();
        this.donor = new DonorService();
        this.externalServices = new ExternalService();
        this.gift = new GiftService();
        this.home = new HomeService();
        this.onlineGiving = new OnlineGivingService();
        this.points = new PointsService();
    }

    public static get instance(): ApiHandler {
        if (!ApiHandler._instance) {
            ApiHandler._instance = new ApiHandler();
        }
        return ApiHandler._instance;
    }
}
